import React from 'react'
import { useSelector } from 'react-redux'
import BasketCounterContextProvider from 'context/BasketContext'
import LayoutContextProvider from 'context/LayoutContext'
import LanguageContextProvider from 'context/LanguageContext'
import ScreenContextProvider from 'context/ScreenContext'
import TermsContextProvider from 'context/TermsContext'
import OrderIdContext from 'context/OrderIdContext'
import LabelContext from 'context/LabelContext'
import ErrorBoundary from 'components/ErrorBoundary'
import { App } from './App'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import routes from 'config/routes'
import siteDownRoutesArray from 'config/routes/siteDownRoute'

const AppRouter = () => {
    const siteDownFlag = useSelector(state => state.configuration.getIn(['7NOW_Web_Offline']))

    const mergedRoutes = siteDownFlag ? siteDownRoutesArray : routes
    const router = createBrowserRouter([
        {
            path: '/*',
            element: (
                <ErrorBoundary>
                    <BasketCounterContextProvider>
                        <LayoutContextProvider>
                            <LanguageContextProvider>
                                <ScreenContextProvider>
                                    <TermsContextProvider>
                                        <OrderIdContext>
                                            <LabelContext>
                                                <App />
                                            </LabelContext>
                                        </OrderIdContext>
                                    </TermsContextProvider>
                                </ScreenContextProvider>
                            </LanguageContextProvider>
                        </LayoutContextProvider>
                    </BasketCounterContextProvider>
                </ErrorBoundary>
            ),
            children: mergedRoutes,
        },
    ])
    return <RouterProvider router={router} />
}

export default AppRouter
